module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "collection-container",
    staticClass: "collection",
    class: {
      'collection-swiper-container': _vm.sliderMode
    }
  }, [(_vm.displayTitle) ? _c('h2', {
    staticClass: "padding-left-sm-0 padding-right-sm-0 margin-bottom-sm-1 margin-bottom-xs-1"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('div', {
    staticClass: "relative",
    class: {
      'swiper-container': _vm.sliderMode
    }
  }, [(_vm.sliderMode) ? [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.items), function(item, idx) {
    return (_vm.itemsFiltered.indexOf(item) !== -1) ? _c('div', {
      staticClass: "swiper-slide",
      class: {
        'sold-out': item.availability == 'O'
      }
    }, [_c('div', {
      staticClass: "case mb1 artwork"
    }, [_c('div', {
      staticClass: "relative text-center"
    }, [_c('a', {
      attrs: {
        "href": item.art_work_url
      }
    }, [_c('img', {
      staticClass: "slide-image block",
      attrs: {
        "src": item.art_work_preview
      }
    })]), _c('footer', {
      staticClass: "relative"
    }, [_c('div', {
      staticClass: "main-info flex-box",
      attrs: {
        "layout": "row",
        "layout-align": "start"
      }
    }, [_c('div', {
      class: 'text-center',
      attrs: {
        "flex": "flex",
        "data-sub-title": _vm.custom.items[idx] ? (_vm.custom.items[idx].subTitle || false) : false
      }
    }, [_c('a', {
      staticClass: "name text-grey1 ellipsis",
      attrs: {
        "href": item.art_work_url
      }
    }, [_vm._v(_vm._s(item.seo_prefix ? ((item.seo_prefix) + " - ") : '') + _vm._s(item.artwork_desc))]), _c('span', {
      staticClass: "ellipsis text-grey3 price"
    }, [_vm._v(_vm._s((_vm.displayPrice && item.price) ? item.price : ' '))])])])])])])]) : _vm._e()
  }))] : [(_vm.itemsFiltered.length) ? _c('ul', {
    ref: "ul",
    staticClass: "row reset-list relative"
  }, _vm._l((_vm.items), function(item, idx) {
    return (_vm.itemsFiltered.indexOf(item) !== -1) ? _c('li', {
      staticClass: "case mb1 artwork",
      class: ['column3', 'xs-column6', 'xs-thin-column'].concat(item.availability == 'O' ? ['sold-out'] : [])
    }, [_c('div', {
      staticClass: "relative text-center"
    }, [_c('a', {
      attrs: {
        "href": item.art_work_url
      }
    }, [_c('img', {
      staticClass: "case-img f-width flex-img block",
      attrs: {
        "src": item.art_work_preview
      }
    })]), _c('footer', {
      staticClass: "relative"
    }, [_c('div', {
      staticClass: "main-info flex-box",
      attrs: {
        "layout": "row",
        "layout-align": "start"
      }
    }, [_c('div', {
      class: 'text-left',
      attrs: {
        "flex": "flex",
        "data-sub-title": _vm.custom.items[idx] ? (_vm.custom.items[idx].subTitle || false) : false
      }
    }, [_c('a', {
      staticClass: "name text-grey1 ellipsis",
      attrs: {
        "href": item.art_work_url
      }
    }, [_vm._v(_vm._s(item.seo_prefix ? ((item.seo_prefix) + " - ") : '') + _vm._s(item.artwork_desc))]), _c('span', {
      staticClass: "ellipsis text-grey3 price"
    }, [_vm._v(_vm._s((_vm.displayPrice && item.price) ? item.price : ' '))])])])])])]) : _vm._e()
  })) : _vm._e()]], 2), (_vm.sliderMode) ? _c('div', {
    staticClass: "swiper-button-prev"
  }) : _vm._e(), (_vm.sliderMode) ? _c('div', {
    staticClass: "swiper-button-next"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20e974d8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CMSCollection.vue
// module id = 284
// module chunks = 15